<template>
  <v-card>
    <v-card-title>
      Steuer Bearbeiten
    </v-card-title>
    <v-form @submit.prevent="save()">
      <v-row>
        <v-col>
          <v-text-field
            v-model="editForm.name"
            label="Bezeichnung"
            outlined
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="editForm.percent"
            label="Prozent Angabe"
            outlined
          />
        </v-col>
        <v-col
          class="d-flex justify-end"
        >
          <v-btn
            type="submit"
            color="primary"
          >
            Speichern
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
export default {
   name: 'SettingsTaxEdit',
   props: {
      tax: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         editForm: {
            name: this.tax.name,
            percent: this.tax.percent
         }
      }
   },
   methods: {
      save () {
         this.$inertia.patch(this.route('tax.update', this.tax.id), this.editForm)
      }
   }
}
</script>

<style>

</style>
